var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height",attrs:{"id":"industrial-map-page-container"}},[_c('MapaIndustrialDinamico')],1)}
var staticRenderFns = []

export { render, staticRenderFns }